import React from 'react';
import API from '../API';
import SearchCoreModal, { SearchCoreProps } from './SearchCoreModal';
import { PaymentTerminal } from '../AdminClasses';

var SearchTerminalModal = (props: SearchCoreProps<PaymentTerminal>)=>{
	return <SearchCoreModal
		title='Buscar terminal'
		{...props}
		searchData={(query, page, page_size)=>{
			return API.getPaymentTerminalList(query, page * page_size, page_size);
		}}
		pageSize={15}
		table={[
			{ name: 'ID', key: 'terminal_id', collapsing: true },
			{ name: 'Terminal', key: 'terminal_name' },
		]}
	/>
}

export default SearchTerminalModal;